<template>
  <div class="file-upload">
    <el-upload
      v-if="!disabled"
      action="#"
      :accept="accept"
      :multiple="multiple"
      :limit="multiple ? limit : 1"
      :file-list="fileList"
      :http-request="handleUpload"
      :on-remove="handleRemove"
      :before-upload="beforeUpload"
    >
      <el-button size="small" type="primary" icon="el-icon-upload2">
        选择文件
      </el-button>
      <div slot="tip" class="el-upload__tip">
        支持 PDF、图片及 Word 文件，单个文件不超过 20MB
      </div>
    </el-upload>
    <div v-else-if="!urls.length" class="empty-text">暂无文件</div>
    <div v-if="disabled" class="readonly-files">
      <el-link
        v-for="(url, index) in urls"
        :key="url + index"
        :href="url"
        target="_blank"
        type="primary"
        :underline="false"
      >
        <i class="el-icon-document" /> {{ fileName(url) }}
      </el-link>
    </div>
  </div>
</template>

<script>
import { uploadOfflineBusinessFile } from "@/api/offline-business-order";

export default {
  name: "OfflineBusinessFileUpload",
  props: {
    value: {
      type: [String, Array],
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      accept: ".pdf,.jpg,.jpeg,.png,.doc,.docx"
    };
  },
  computed: {
    urls() {
      if (Array.isArray(this.value)) {
        return this.value.filter(Boolean);
      }
      return this.value ? [this.value] : [];
    },
    fileList() {
      return this.urls.map((url, index) => ({
        name: this.fileName(url),
        url,
        uid: `${url}-${index}`
      }));
    }
  },
  methods: {
    beforeUpload(file) {
      const allowed = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ];
      const validType =
        allowed.includes(file.type) ||
        /\.(pdf|jpe?g|png|docx?)$/i.test(file.name);
      const validSize = file.size / 1024 / 1024 <= 20;
      if (!validType) this.$message.error("文件格式不支持");
      if (!validSize) this.$message.error("单个文件不能超过 20MB");
      return validType && validSize;
    },
    async handleUpload(options) {
      const formData = new FormData();
      formData.append("fileVal", options.file);
      try {
        const res = await uploadOfflineBusinessFile(formData);
        const url =
          res &&
          (typeof res.data === "string" ? res.data : res.data && res.data.url);
        if (!url) throw new Error("upload failed");
        const nextValue = this.multiple ? [...this.urls, url] : url;
        this.$emit("input", nextValue);
        options.onSuccess(res);
        this.$message.success("上传成功");
      } catch (error) {
        options.onError(error);
        this.$message.error("上传失败");
      }
    },
    handleRemove(file) {
      const nextUrls = this.urls.filter(url => url !== file.url);
      this.$emit("input", this.multiple ? nextUrls : "");
    },
    fileName(url) {
      const cleanUrl = String(url || "").split("?")[0];
      return decodeURIComponent(cleanUrl.split("/").pop() || "查看文件");
    }
  }
};
</script>

<style lang="less" scoped>
.readonly-files {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.empty-text {
  color: #909399;
}
</style>
